import * as React from "react";
import type { SVGProps } from "react";

const ConnectorType1 = React.memo((props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    focusable="false"
    {...props}
  >
    <path
      vectorEffect="non-scaling-stroke"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.1993 18.3352L14 18.8592V20.1679V21H10V20.1679V18.8592L8.80074 18.3352C5.97111 17.0989 4 14.2774 4 11C4 6.58172 7.58172 3 12 3C16.4183 3 20 6.58172 20 11C20 14.2774 18.0289 17.0989 15.1993 18.3352ZM16 21V20.1679C19.5318 18.6248 22 15.1006 22 11C22 5.47715 17.5228 1 12 1C6.47715 1 2 5.47715 2 11C2 15.1006 4.46819 18.6248 8 20.1679V21C8 22.1046 8.89543 23 10 23H14C15.1046 23 16 22.1046 16 21ZM12 18C13.1046 18 14 17.1046 14 16C14 14.8954 13.1046 14 12 14C10.8954 14 10 14.8954 10 16C10 17.1046 10.8954 18 12 18ZM18 13C18 14.1046 17.1046 15 16 15C14.8954 15 14 14.1046 14 13C14 11.8954 14.8954 11 16 11C17.1046 11 18 11.8954 18 13ZM8 15C9.10457 15 10 14.1046 10 13C10 11.8954 9.10457 11 8 11C6.89543 11 6 11.8954 6 13C6 14.1046 6.89543 15 8 15ZM17 8C17 9.10457 16.1046 10 15 10C13.8954 10 13 9.10457 13 8C13 6.89543 13.8954 6 15 6C16.1046 6 17 6.89543 17 8ZM9 10C10.1046 10 11 9.10457 11 8C11 6.89543 10.1046 6 9 6C7.89543 6 7 6.89543 7 8C7 9.10457 7.89543 10 9 10Z"
      fill="currentColor"
    />
  </svg>
));
ConnectorType1.displayName = "ConnectorType1";

export default ConnectorType1;
